function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/*********************************************************************************

 NFT CRYPTO MODULE

 Treats a single NFT (by nft_id) as a CryptoModule so it can be:
  - displayed in the wallet
  - selected as a payment asset
  - transferred fractionally
  - staked / wagered by games

 One instance == one NFT id (aggregates all owned slips)

**********************************************************************************/

var CryptoModule = require('./cryptomodule');
var NFTCryptoModule = /*#__PURE__*/function (_CryptoModule) {
  function NFTCryptoModule(app, nft_id) {
    var _this;
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, NFTCryptoModule);
    // ticker must be unique per NFT
    var ticker = opts.ticker || "NFT-".concat(nft_id.slice(0, 6));
    _this = _callSuper(this, NFTCryptoModule, [app, ticker]);
    _this.name = opts.name || ticker;
    _this.description = opts.description || 'NFT Asset';
    _this.categories = 'NFT';

    // NFT identity
    _this.nft_id = nft_id;

    // NFTs are local UTXO assets
    _this.confirmations = 0;
    _this.warning = '';
    _this.introduction = '';

    // NFTs do not have external addresses
    _this.address = _this.app.wallet.publicKey;

    // History is intentionally unsupported
    _this.history = null;
    _this.history_update_ts = 0;

    // Mark as activated immediately
    _this.options.isActivated = true;
    return _this;
  }

  /********************************************************
   * REQUIRED CRYPTOMODULE INTERFACE
   ********************************************************/

  /**
   * Internal helper to collect NFT slips from wallet options
   */
  _inherits(NFTCryptoModule, _CryptoModule);
  return _createClass(NFTCryptoModule, [{
    key: "_returnNFTSlips",
    value: function _returnNFTSlips() {
      var _this$app,
        _this2 = this;
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$unreserved = opts.unreserved,
        unreserved = _opts$unreserved === void 0 ? false : _opts$unreserved,
        _opts$state = opts.state,
        state = _opts$state === void 0 ? 'unspent' : _opts$state,
        _opts$limit = opts.limit,
        limit = _opts$limit === void 0 ? null : _opts$limit;
      if (!((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.options) !== null && _this$app !== void 0 && (_this$app = _this$app.wallet) !== null && _this$app !== void 0 && _this$app.nfts)) {
        return [];
      }
      var slips = this.app.options.wallet.nfts.filter(function (n) {
        return n.id === _this2.nft_id;
      });
      if (unreserved) {
        slips = slips.filter(function (s) {
          return !s.reserved;
        });
      }
      if (state === 'unspent') {
        slips = slips.filter(function (s) {
          return !s.spent;
        });
      }
      if (limit) {
        slips = slips.slice(0, limit);
      }
      return slips;
    }
  }, {
    key: "checkBalance",
    value: function () {
      var _checkBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var slips, total, _iterator, _step, s;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // Sum all unreserved slips for this NFT id
              slips = this._returnNFTSlips({
                unreserved: true
              });
              total = BigInt(0);
              _iterator = _createForOfIteratorHelper(slips);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  s = _step.value;
                  try {
                    total += BigInt(s.amount);
                  } catch (err) {}
                }

                // CryptoModule expects a string
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              this.balance = total.toString();
              return _context.a(2, this.balance);
          }
        }, _callee, this);
      }));
      function checkBalance() {
        return _checkBalance.apply(this, arguments);
      }
      return checkBalance;
    }()
  }, {
    key: "returnBalance",
    value: function returnBalance() {
      return this.balance || '0';
    }
  }, {
    key: "returnAddress",
    value: function returnAddress() {
      // NFTs are sent to public keys, not external addresses
      return this.app.wallet.publicKey;
    }
  }, {
    key: "formatAddress",
    value: function formatAddress() {
      return this.returnAddress();
    }
  }, {
    key: "returnPrivateKey",
    value: function returnPrivateKey() {
      // NFTs are controlled by the wallet key
      return this.app.wallet.returnPrivateKey();
    }
  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var amount,
          recipient,
          unique_hash,
          tx,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              amount = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              recipient = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
              unique_hash = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
              if (!(!amount || BigInt(amount) <= 0n)) {
                _context2.n = 1;
                break;
              }
              throw new Error('NFTCryptoModule: invalid amount');
            case 1:
              // Defensive recipient handling
              if (!recipient || typeof recipient !== 'string') {
                recipient = this.app.wallet.publicKey;
              } else {
                recipient = recipient.trim();

                // If wallet has validation function, use it safely
                if (this.app.wallet.isValidPublicKey && typeof this.app.wallet.isValidPublicKey === 'function') {
                  if (!this.app.wallet.isValidPublicKey(recipient)) {
                    recipient = this.app.wallet.publicKey;
                  }
                } else {
                  // Fallback heuristic: require reasonable length
                  if (recipient.length < 20) {
                    recipient = this.app.wallet.publicKey;
                  }
                }
              }

              // Construct NFT transfer transaction
              _context2.n = 2;
              return this.app.wallet.createNFTTransferTransaction(this.nft_id, BigInt(amount), recipient);
            case 2:
              tx = _context2.v;
              if (tx) {
                _context2.n = 3;
                break;
              }
              throw new Error('NFTCryptoModule: unable to construct NFT transfer');
            case 3:
              _context2.n = 4;
              return tx.sign();
            case 4:
              _context2.n = 5;
              return this.app.network.propagateTransaction(tx);
            case 5:
              return _context2.a(2, unique_hash || tx.signature);
          }
        }, _callee2, this);
      }));
      function sendPayment() {
        return _sendPayment.apply(this, arguments);
      }
      return sendPayment;
    }()
  }, {
    key: "receivePayment",
    value: function () {
      var _receivePayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var amount,
          sender,
          recipient,
          timestamp,
          unique_hash,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              amount = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
              sender = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';
              recipient = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : '';
              timestamp = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 0;
              unique_hash = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : '';
              return _context3.a(2, true);
          }
        }, _callee3);
      }));
      function receivePayment() {
        return _receivePayment.apply(this, arguments);
      }
      return receivePayment;
    }()
    /********************************************************
     * OPTIONAL / OVERRIDDEN BEHAVIOR
     ********************************************************/
  }, {
    key: "checkHistory",
    value: function () {
      var _checkHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var callback,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              callback = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
              // Explicitly unsupported for NFTs
              if (callback) {
                callback([]);
              }
              return _context4.a(2, []);
          }
        }, _callee4);
      }));
      function checkHistory() {
        return _checkHistory.apply(this, arguments);
      }
      return checkHistory;
    }()
  }, {
    key: "fetchPendingDeposits",
    value: function () {
      var _fetchPendingDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var callback,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              callback = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
              if (callback) {
                callback([]);
              }
              return _context5.a(2, []);
          }
        }, _callee5);
      }));
      function fetchPendingDeposits() {
        return _fetchPendingDeposits.apply(this, arguments);
      }
      return fetchPendingDeposits;
    }()
  }, {
    key: "validateAddress",
    value: function validateAddress(address) {
      return this.app.wallet.isValidPublicKey(address);
    }
  }, {
    key: "returnUtxo",
    value: function () {
      var _returnUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var state,
          limit,
          order,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              state = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : 'unspent';
              limit = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 1000;
              order = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : 'DESC';
              return _context6.a(2, this._returnNFTSlips({
                state: state,
                limit: limit
              }));
          }
        }, _callee6, this);
      }));
      function returnUtxo() {
        return _returnUtxo.apply(this, arguments);
      }
      return returnUtxo;
    }()
  }, {
    key: "returnNetworkInfo",
    value: function () {
      var _returnNetworkInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              return _context7.a(2, {
                confirmations: 0
              });
          }
        }, _callee7);
      }));
      function returnNetworkInfo() {
        return _returnNetworkInfo.apply(this, arguments);
      }
      return returnNetworkInfo;
    }()
  }]);
}(CryptoModule);
module.exports = NFTCryptoModule;